import DashboardCard from "./DashboardCard";

export default DashboardCard;